
/**
 * Content Delivery Network (CDN) configuration
 */

// CDN base URL - pulled from environment variable or use default
export const CDN_URL = import.meta.env.VITE_CDN_URL || "https://cdn.cplk.org";

// Default fallback image if no image is available
export const DEFAULT_IMAGE = "/placeholder-property.avif";

// Set a flag to track if an image is a placeholder to prevent infinite loading
const placeholderTracking = new Set<string>();

/**
 * Build a CDN image URL based on property listing code and image number
 * Used primarily for property cards and listings
 * 
 * @param listingCode - The property listing code (e.g., C03-HR008)
 * @param imageNumber - The image number (default: 1)
 * @returns Full CDN URL for the image or DEFAULT_IMAGE if no listing code
 */
export function getPropertyImageUrl(listingCode?: string | null, imageNumber: number = 1): string {
  if (!listingCode) {
    return DEFAULT_IMAGE;
  }
  
  // Return CDN URL with fallback handling
  return `${CDN_URL}/${listingCode}/${imageNumber}.avif`;
}

/**
 * Checks if a URL is already using the placeholder image
 * Used to prevent infinite loading loops
 * 
 * @param url The URL to check
 * @returns true if the URL is already using the placeholder image
 */
export function isPlaceholder(url: string): boolean {
  return url === DEFAULT_IMAGE || placeholderTracking.has(url);
}

/**
 * Marks a URL as having been replaced with the placeholder
 * This prevents infinite loading loops
 * 
 * @param url The URL that was replaced with a placeholder
 */
export function markAsPlaceholder(url: string): void {
  placeholderTracking.add(url);
}
